"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsWeb = require("@telus-uds/components-web");
var _utils = require("../utils");
var _staticContent = require("../staticContent");
var _constants = require("../constants");
var _useStepTrackerContext = _interopRequireDefault(require("../hooks/useStepTrackerContext"));
var _FieldWrapper = _interopRequireDefault(require("../FieldWrapper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var validate = (value, isRequired, options) => {
  var isValid = true;

  // We need to check if field is required, if so then check that something is selected
  isValid = isValid && (isRequired ? value.length > 0 : true);
  isValid = isValid && Array.isArray(options) && (options.some(option => option.value === value) || !isRequired);
  return isValid;
};
var DropdownListField = props => {
  var {
    hintPosition = _constants.FIELD_HINT_POSITION.BELOW,
    value,
    options,
    onChange = () => {},
    isRequired = false,
    clickedSubmit = false,
    language = _constants.CONTENTFUL_LOCALE.en,
    customErrorMessage = '',
    label = _staticContent.DROPDOWN_FIELD.DEFAULT_LABEL,
    hint,
    inputRef = /*#__PURE__*/(0, _react.createRef)(),
    isReadOnly = false
  } = props;
  var [validationError, setValidationError] = (0, _react.useState)(undefined);
  var [validationFeedback, setValidationFeedback] = (0, _react.useState)(undefined);
  var [dropdownValue, setDropdownValue] = (0, _react.useState)(value);
  var {
    buttonControlPressed,
    currentStepReferences
  } = (0, _useStepTrackerContext.default)();
  (0, _react.useEffect)(() => {
    var hasValue = options.filter(item => item.value === dropdownValue);
    var valueToUse = hasValue ? dropdownValue : '';
    onChange(valueToUse, validate(valueToUse, isRequired, options));
  }, [dropdownValue, isRequired, onChange, options]);
  var updateValidationError = (0, _react.useCallback)(isValid => {
    setValidationError(isValid ? undefined : customErrorMessage || _staticContent.DROPDOWN_FIELD.VALIDATION_ERROR[language]);
    setValidationFeedback(isValid ? _constants.FIELD_FEEDBACK.SUCCESS : _constants.FIELD_FEEDBACK.ERROR);
  }, [customErrorMessage, language]);
  (0, _react.useEffect)(() => {
    if (clickedSubmit) {
      updateValidationError(validate(value, isRequired, options));
    }
  }, [clickedSubmit, isRequired, updateValidationError, value, label, options]);
  (0, _react.useEffect)(() => {
    if (buttonControlPressed) {
      if ((0, _utils.isStepInput)(inputRef, currentStepReferences)) {
        updateValidationError(validate(value, isRequired, options));
      }
    }
  }, [buttonControlPressed, currentStepReferences, inputRef, isRequired, options, updateValidationError, value]);
  (0, _react.useEffect)(() => {
    if (!validate(value, isRequired, options)) {
      setDropdownValue('');
    }
  }, [value, options, isRequired]);
  var onFieldChange = id => {
    updateValidationError(validate(id, isRequired, options));
    setDropdownValue(id);
  };
  return /*#__PURE__*/_react.default.createElement(_FieldWrapper.default, null, options.length > 0 && /*#__PURE__*/_react.default.createElement(_componentsWeb.Select, {
    ref: inputRef,
    label: (0, _utils.formatLabel)(label, isRequired, language),
    hint: hint,
    hintPosition: hintPosition,
    value: dropdownValue,
    placeholder: _staticContent.DROPDOWN_FIELD.PLACEHOLDER[language],
    onChange: onFieldChange,
    validation: validationFeedback,
    feedback: validationError,
    "data-di-mask": true,
    testID: 'dropdown-list-test',
    inactive: isReadOnly
  }, options.map(option => /*#__PURE__*/_react.default.createElement(_componentsWeb.Select.Item, {
    key: "dropdown-item-".concat(option.id),
    value: option.value
  }, option.label))));
};
DropdownListField.propTypes = {
  label: _propTypes.default.string,
  hint: _propTypes.default.string,
  hintPosition: _propTypes.default.oneOf(['inline', 'below']),
  onChange: _propTypes.default.func,
  value: _propTypes.default.string,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.string,
    id: _propTypes.default.string
  }).isRequired),
  isRequired: _propTypes.default.bool,
  language: _propTypes.default.string,
  inputRef: _propTypes.default.object,
  clickedSubmit: _propTypes.default.bool,
  customErrorMessage: _propTypes.default.string,
  isReadOnly: _propTypes.default.bool
};
DropdownListField.defaultProps = {
  label: _staticContent.DROPDOWN_FIELD.DEFAULT_LABEL,
  hint: null,
  hintPosition: _constants.FIELD_HINT_POSITION.BELOW,
  onChange: () => {},
  value: '',
  options: [],
  isRequired: false,
  language: _constants.CONTENTFUL_LOCALE.en,
  inputRef: /*#__PURE__*/(0, _react.createRef)(),
  clickedSubmit: false,
  customErrorMessage: '',
  isReadOnly: false
};
var _default = exports.default = DropdownListField;